<template>
    <v-btn-toggle
        :value="currentType"
        mandatory
        class="phase-toggle"
        :class="{ 'phase-toggle--compact': compact }"
        @change="onChange"
    >
        <v-btn
            v-for="item in matchTypes"
            :key="item.value"
            :value="item.value"
            small
            class="phase-toggle__btn"
        >
            <!-- on a phone the tap picks the phase; the count is on the button anyway -->
            <info-tip :text="hint(item.value) || ''" hover-only bottom>
                <v-icon v-if="item.value === 'cup'" x-small left>mdi-trophy</v-icon>
                {{ item.title }}
                <span v-if="countOf(item.value).live" class="phase-count phase-count--live">
                    <span class="phase-count__dot" />
                    LIVE
                </span>
                <span v-else-if="countOf(item.value).upcoming" class="phase-count">{{ countOf(item.value).upcoming }}</span>
            </info-tip>
        </v-btn>
    </v-btn-toggle>
</template>

<script>
    // Phase picker of the team and player pages; the parent owns the selected phase
    export default {
        props: {
            compact: {
                type: Boolean,
                default: false
            },
            currentType: {
                type: String,
                default: 'regular_season'
            },
            // Optional { phase: { upcoming, live } }: hints which phases still have matches to watch
            counts: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                matchTypes: [
                    { title: 'Προκριματικά', value: 'placements' },
                    { title: 'Regular Season', value: 'regular_season' },
                    { title: 'Playoffs', value: 'playoffs' },
                    { title: 'Κύπελλο', value: 'cup' }
                ]
            }
        },
        methods: {
            countOf(phase) {
                return (this.counts && this.counts[phase]) || { upcoming: 0, live: 0 }
            },
            hint(phase) {
                if (!this.counts) return null
                const { upcoming, live } = this.countOf(phase)
                const parts = []
                if (live) parts.push(`${live} live`)
                if (upcoming) parts.push(`${upcoming} ${upcoming === 1 ? 'επόμενος αγώνας' : 'επόμενοι αγώνες'}`)
                return parts.length ? parts.join(', ') : 'Δεν υπάρχουν επόμενοι αγώνες'
            },
            onChange(value) {
                if (value && value !== this.currentType) {
                    this.$emit('setType', value)
                }
            }
        }
    }
</script>

<style>
/* Kept from the previous chip version: other slide groups (e.g. the team tabs) rely on it */
.v-slide-group__content {
    justify-content: center !important;
}
</style>

<style scoped>
.phase-toggle {
    flex-wrap: wrap;
    justify-content: center;
    background: #0d0d0f !important;
    border-radius: 8px !important;
    padding: 3px;
}

.phase-toggle .phase-toggle__btn {
    background: transparent !important;
    border: none !important;
    border-radius: 6px !important;
    color: rgba(255, 255, 255, 0.75) !important;
    font-family: Ubuntu, Arial, sans-serif;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: none;
    height: 32px !important;
}

.phase-toggle .phase-toggle__btn .v-icon {
    color: inherit !important;
}

.phase-toggle .phase-toggle__btn.v-btn--active {
    background: linear-gradient(90deg, #ef4444 0%, #ff7133 50%, orange 100%) !important;
    color: #fff !important;
}

.phase-toggle .phase-toggle__btn.v-btn--active::before {
    opacity: 0 !important;
}

.phase-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    margin-left: 6px;
    padding: 0 5px;
    border-radius: 9px;
    background: rgba(255, 255, 255, 0.18);
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0;
}

/* A phase with a match being played right now */
.phase-count--live {
    gap: 3px;
    background: #ef4444;
    color: #fff;
    font-size: 0.6rem;
    letter-spacing: 0.05em;
}

.phase-count__dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #fff;
    animation: phase-live 1.2s ease-in-out infinite;
}

@keyframes phase-live {
    50% {
        opacity: 0.25;
    }
}

@media (prefers-reduced-motion: reduce) {
    .phase-count__dot {
        animation: none;
    }
}

.phase-toggle--compact .phase-toggle__btn {
    height: 26px !important;
    padding: 0 8px !important;
    font-size: 0.7rem;
}
</style>
